export const select = () => (
  <path
    d="M8 15l4 4 4-4m0-6l-4-4-4 4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
